export const pouchesRollsHeroContent = {
  badge: 'Premium Quality Solution',
  scriptTitle: 'Our Premium',
  mainTitleLines: ['Pouches &', 'Rolls'],
  kicker: 'Flexible Packaging & Barrier Performance',
  descriptions: [
    'Engineered for stand-up pouches and flexible packaging, our pouches and rolls paper combines multi-layer barrier protection with clean formability for modern high-speed converting lines.',
    'From food and FMCG brands to industrial packaging units, our roll stock supports vibrant printing, tight heat sealing, and consistent bulk performance with dependable supply across India.',
  ],
  features: [
    'Multi-Layer Barrier',
    'Heat Sealable',
    'High-Speed Converting',
    'Custom Roll Widths',
  ],
  imagePrimary: {
    src: '/images/products/Pouches-Rolls1 (1).png',
    alt: 'Flexible stand-up pouches packaging rolls',
  },
  imageSecondary: {
    src: '/images/products/Pouches-Rolls1 (2).png',
    alt: 'Industrial pouches and rolls manufacturing',
  },
};

export const pouchesRollsSpecs = {
  businessType: {
    label: "Business Type",
    value: "Manufacturer, Exporter, Supplier, Wholesaler",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
  },
  location: {
    label: "Buyer Preferred Location",
    value: "Pan India Supply + Export",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
  },
  type: {
    label: "Type",
    value: "Pouches & Rolls",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  color: {
    label: "Color",
    value: "White / Natural Kraft / Custom Printed",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
        <path d="M7.5 10.5C8.32843 10.5 9 9.82843 9 9C9 8.17157 8.32843 7.5 7.5 7.5C6.67157 7.5 6 8.17157 6 9C6 9.82843 6.67157 10.5 7.5 10.5Z" />
        <path d="M11.5 7.5C12.3284 7.5 13 6.82843 13 6C13 5.17157 12.3284 4.5 11.5 4.5C10.6716 4.5 10 5.17157 10 6C10 6.82843 10.6716 7.5 11.5 7.5Z" />
        <path d="M16.5 10.5C17.3284 10.5 18 9.82843 18 9C18 8.17157 17.3284 7.5 16.5 7.5C15.6716 7.5 15 8.17157 15 9C15 9.82843 15.6716 10.5 16.5 10.5Z" />
        <path d="M6 14C6 14 7.5 19 12 19C16.5 19 18 14 18 14" />
      </svg>
    ),
  },
  coating: {
    label: "Coating",
    value: "PE Coated Food Grade",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    ),
  },
  material: {
    label: "Material",
    value: "Multi-Layer Pouch Paper / Kraft Paper",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
      </svg>
    ),
  },
  gsm: {
    label: "GSM",
    value: "40 GSM – 120 GSM (Custom Available)",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 7V4h16v3" />
        <path d="M9 20h6" />
        <path d="M12 4v16" />
      </svg>
    ),
  },
  usage: {
    label: "Usage",
    value: "Stand-up Pouches, Sachets, Flexible Food Packaging",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27,6.96 12,12.01 20.73,6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
      </svg>
    ),
  },
  thickness: {
    label: "Thickness",
    value: "As per requirement",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="6" />
        <circle cx="12" cy="12" r="2" />
      </svg>
    ),
  },
  feature: {
    label: "Feature",
    value: "Moisture & Oxygen Barrier, Heat Sealable, High Printability",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
  },
  industrialUse: {
    label: "Industrial Use",
    value: "Pouch Making, Lamination & Converting",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="8" rx="2" />
        <rect x="2" y="14" width="20" height="8" rx="2" />
        <line x1="6" y1="10" x2="6" y2="14" />
        <line x1="18" y1="10" x2="18" y2="14" />
      </svg>
    ),
  },
  sizes: {
    label: "Sizes",
    value: "As per requirement",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="21 8 21 21 8 21" />
        <rect x="3" y="3" width="14" height="14" rx="2" ry="2" />
      </svg>
    ),
  },
};

export const pouchesRollsBenefits = [
  {
    title: "Flexible Packaging",
    description: "Ideal material for stand-up pouches and flexible packaging solutions with excellent formability and converting efficiency.",
  },
  {
    title: "Extended Shelf Life",
    description: "Superior barrier properties protect products against moisture and oxygen, helping extend shelf life and maintain freshness.",
  },
  {
    title: "High Print Quality",
    description: "Premium surface supports vibrant, high-resolution printing that enhances brand visibility and shelf appeal.",
  },
  {
    title: "Cost Efficient",
    description: "Lightweight roll format reduces shipping and storage costs while delivering reliable protection compared to rigid packaging.",
  },
];
